/**
 * Narrow presentation-title resolver for the IndexPage App-titleControl.
 *
 * Flarum 1.8.19 SelectDropdown.getButtonContent() uses the first active child
 * label, else defaultLabel. On `/` the active All Discussions child therefore
 * wins over the generic center-menu label. Return a string to override that
 * label, or null to leave core SelectDropdown behavior unchanged.
 */

import { START_NAV_LABEL } from './startNav.js';
export const TECHNICIAN_TOPICS_SLUG = 'general-shop-discussion';
export const START_HERE_SLUG = 'start-here';
export const PICK_A_BRAND = 'FlatRate.wiki';
export const TECHNICIAN_TOPICS_LABEL = 'Technician Topics';
export const START_HERE_LABEL = START_NAV_LABEL;
export const PUSH_TO_START_LABEL = START_NAV_LABEL;
function tagSlug(currentTag) {
  if (!currentTag) return '';
  if (typeof currentTag.slug === 'function') return String(currentTag.slug() || '');
  return String(currentTag.slug || '');
}
function hasSearchQuery(searchContext) {
  if (!searchContext || typeof searchContext !== 'object') return false;
  const q = searchContext.q ?? searchContext.query;
  return typeof q === 'string' && q.trim() !== '';
}
function isFollowingContext(_ref) {
  let {
    activeCoreContext,
    routeName,
    searchContext
  } = _ref;
  if (activeCoreContext === 'following') return true;
  if (routeName === 'following') return true;
  return !!(searchContext && searchContext.onFollowing === true);
}
function isCanonicalUnfilteredIndex(_ref2) {
  let {
    currentTag,
    routeName,
    searchContext,
    routeContext
  } = _ref2;
  if (currentTag) return false;
  if (hasSearchQuery(searchContext)) return false;
  if (routeContext && routeContext.tags) return false;
  const params = searchContext || {};
  if (params.tags) return false;
  if (routeName && routeName !== 'index' && routeName !== 'default') return false;
  return true;
}

/**
 * @returns {string|null} presentation title, or null for core SelectDropdown
 */
export function resolvePresentationTitle(_temp) {
  let {
    currentTag = null,
    routeName = '',
    routeContext = {},
    searchContext = {},
    activeCoreContext = '',
    manifest = null
  } = _temp === void 0 ? {} : _temp;
  if (isFollowingContext({
    activeCoreContext,
    routeName,
    searchContext
  })) {
    return null;
  }
  if (hasSearchQuery(searchContext)) {
    return null;
  }
  const slug = tagSlug(currentTag) || searchContext && searchContext.tags || routeContext && routeContext.tags || '';
  if (slug) {
    if (slug === TECHNICIAN_TOPICS_SLUG) return TECHNICIAN_TOPICS_LABEL;
    if (slug === START_HERE_SLUG) return PICK_A_BRAND;
    const brandName = canonicalBrandName(manifest, slug);
    if (brandName) return brandName;
    return PICK_A_BRAND;
  }
  if (isCanonicalUnfilteredIndex({
    currentTag,
    routeName,
    searchContext,
    routeContext
  })) {
    return PICK_A_BRAND;
  }
  return null;
}
function canonicalBrandName(manifest, slug) {
  const needle = String(slug || '');
  if (!needle || !manifest || !Array.isArray(manifest.groups)) return null;
  const brands = manifest.groups.find(group => group && group.mode === 'tree' && group.id === 'brands');
  let found = null;
  function visit(board) {
    if (!board || found) return;
    if (String(board.slug || '') === needle) {
      found = board;
      return;
    }
    (board.children || []).forEach(visit);
  }
  (brands?.boards || []).forEach(visit);
  const name = found && found.name ? String(found.name) : '';
  return name || null;
}

/**
 * CSS mode for the IndexPage center control.
 * root keeps the FLATRATE.WIKI mask. contextual and technician use DOM text.
 * null leaves core SelectDropdown labeling in place.
 */
export function resolvePresentationTitleMode(context) {
  if (context === void 0) {
    context = {};
  }
  const title = resolvePresentationTitle(context);
  if (title == null) return null;
  if (title === TECHNICIAN_TOPICS_LABEL) return 'technician';
  if (title === PICK_A_BRAND) return 'root';
  return 'contextual';
}
flarum.reg.add('flatrate-forum-navigation', 'forum/utils/presentationTitle', { TECHNICIAN_TOPICS_SLUG: TECHNICIAN_TOPICS_SLUG,START_HERE_SLUG: START_HERE_SLUG,PICK_A_BRAND: PICK_A_BRAND,TECHNICIAN_TOPICS_LABEL: TECHNICIAN_TOPICS_LABEL,START_HERE_LABEL: START_HERE_LABEL,PUSH_TO_START_LABEL: PUSH_TO_START_LABEL,resolvePresentationTitle: resolvePresentationTitle,resolvePresentationTitleMode: resolvePresentationTitleMode, });